import styled from 'styled-components';

export const Wrapper = styled.div`
    width: 100%;
    padding-left: 0.9375rem;
    padding-right: 0.9375rem;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    min-height: 46px;
    border-bottom: ${props => props.borderBottom ? `1px solid #F1F1F1` : "0" };
    /* border-bottom: 1px solid ${({ theme }) => theme.color.light}; */
    background-color: ${({ theme }) => theme.color.white};
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9;
`;

export const Column = styled.div`
    width: 100%;
    background-color: ${({ theme }) => theme.color.transparent};
    display: flex;
    align-items: center;
    justify-content: flex-start;

    &:last-child {
        width: ${props => props.widthSize ? props.widthSize : "100%"};
    }
`;

export const BackButton = styled.button`
    border: 0;
    width: 28px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    background-color: ${({ theme }) => theme.color.transparent};
        
    svg {
        height: 15px;
        width: auto;

        path {
            fill: ${({ theme }) => theme.color.gray};
        }
    }
`;

export const Content = styled.div`
    font-size: 0.9375rem;
    font-weight: ${({ theme }) => theme.fontWeight.fw700};
    width: 100%;
`;